import dynamic from "next/dynamic";

export const FeaturedStrategicPartnerships = dynamic(() => import("./component"));
